import { render, staticRenderFns } from "./formContact.vue?vue&type=template&id=4655494e&scoped=true"
import script from "./formContact.vue?vue&type=script&lang=js"
export * from "./formContact.vue?vue&type=script&lang=js"
import style0 from "./formContact.vue?vue&type=style&index=0&id=4655494e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655494e",
  null
  
)

export default component.exports